import { useMemo, useState } from 'react'

import { ProductV2 } from '@common'

import { addLeadingZeroToNumber, calculateRemainingTime } from '../../utils/timer'
import useInterval from '../../utils/useInterval'

export const useTimedOffer = (product?: ProductV2) => {
  const [timeLeft, setTimeLeft] = useState<number[]>([0, 0, 0, 0])

  const isTimedOffer = !!product?.offerData?.expiresAt
  const offerExpired = useMemo(() => timeLeft[0] < 0, [timeLeft])
  useInterval(
    () => {
      if (product && product.offerData?.expiresAt) {
        setTimeLeft(calculateRemainingTime(product.offerData.expiresAt))
      }
    },
    // Skip creating interval if it's not timed offer or offer is expired
    isTimedOffer && !offerExpired ? 1000 : null,
  )

  const timeLeftText = useMemo(
    () => timeLeft.map((n) => (n <= 0 ? addLeadingZeroToNumber(0) : addLeadingZeroToNumber(n))),
    [timeLeft],
  )

  return {
    isTimedOffer,
    timeLeftText,
    offerExpired,
  }
}
